/*
 * Single shared email normaliser for every outbound Cognito / my-api auth
 * touchpoint (BOARDROOM-2026-08-24-183930 #50 FIX A; audit MY-2026-08-16-092901).
 *
 * Cognito usernames on the consumer pool are case-sensitive while the my-api
 * claim path ALWAYS lowercases (services/my-api/src/store.ts) — an email typed
 * as Case-Variant@Email.com at signup/login therefore minted a case-variant
 * DUPLICATE (or unreachable) Cognito user. Normalise at the BOUNDARY where the
 * value leaves the FE (cognitoAuth / emailProbe / myApi), never deep in
 * components: display values stay exactly as typed.
 */
export function normalizeEmail(email: string): string {
  return email.normalize('NFC').trim().toLowerCase()
}
